import React from "react";
import { Card } from "antd";
import laboratorioCamusso from "../img/desarrollo/trabajos/laboratorioCamusso.png";
import logoLaboratorioCamusso from "../img/home/referencias/laboratorio.svg";
import zanelloIngenieria from "../img/desarrollo/trabajos/zanello1.png";
import logozanelloIngenieria from "../img/home/referencias/zanello.svg";
import josefinaPelayo from "../img/desarrollo/trabajos/josefinaPelayo.png";
import logoJosefinaPelayo from "../img/home/referencias/josefinaPelayo.svg";
import ipecus from "../img/desarrollo/trabajos/ipecus.png";
import logoIpecus from "../img/home/referencias/ipecus.svg";
import owltrack from "../img/desarrollo/trabajos/owltrack.png";
import logoOwltrack from "../img/home/referencias/owltrack.svg";
import argefix from "../img/desarrollo/trabajos/argefix.png";
import logoArgefix from "../img/home/referencias/argefix.svg";
import Vivero from "../img/desarrollo/trabajos/viveroPehuajo.png";
import logoVivero from "../img/home/referencias/vivero.svg";
import diegoFernandez from "../img/desarrollo/trabajos/diegoFernandez.png";
import logoDiegoFernandez from "../img/home/referencias/diegoFernandez.svg";
import cenea from "../img/desarrollo/trabajos/cenea.png";
import logoCenea from "../img/home/referencias/cenea.svg";
import analiaMardaras from "../img/desarrollo/trabajos/analiaMardaras.png";
import logoAnaliaMardaras from "../img/home/referencias/analiaMardaras.svg";
import instituto from "../img/desarrollo/trabajos/instituto.png";
import logoInstituto from "../img/home/referencias/instituto.svg";
import monicaDraghi from "../img/desarrollo/trabajos/monicaDraghi.png";
import logoMonicaDragh from "../img/home/referencias/monicaDraghi.svg";
import neurolog from "../img/desarrollo/trabajos/neurolog.png";
import logoNeurolog from "../img/home/referencias/neurolog.svg";
import obroin from "../img/desarrollo/trabajos/obroin.png";
import logoObroin from "../img/home/referencias/obroin.svg";
import virtualVal from "../img/desarrollo/trabajos/virtualVal.png";
import logoVirtualVal from "../img/home/referencias/virtualVal.svg";
import mundoPiloto from "../img/desarrollo/trabajos/mundoPiloto.png";
import logoMundoPiloto from "../img/home/referencias/mundoPiloto.svg";
import caroroAccesorios from "../img/desarrollo/trabajos/caroroAccesorios.png";
import logoCaroroAccesorios from "../img/home/referencias/caroroAccesorios.svg";
import Slider from "react-slick";
const { Meta } = Card;

export const CardTrabajos = () => {
  const cardsData = [
    {
      buttonUrl: "https://laboratoriocamusso.com.ar/obrassociales.php",
      buttonText: "Visitar sitio",
      imageTop: logoLaboratorioCamusso,
      title: "LABORATORIO CAMUSSO",
      subtitulo: "Sitio web empresarial",
      backgroundImage: laboratorioCamusso,
    },
    {
      buttonUrl: "https://www.zanelloingenieria.com/",
      buttonText: "Visitar sitio",
      imageTop: logozanelloIngenieria,
      title: "ZANELLO INGENIERIA",
      subtitulo: "Sitio web empresarial",
      backgroundImage: zanelloIngenieria,
    },
    {
      buttonUrl: "https://josefinapelayo.com.ar/",
      buttonText: "Visitar sitio",
      imageTop: logoJosefinaPelayo,
      title: "JOSEFINA PELAYO",
      subtitulo: "Sitio web personal",
      backgroundImage: josefinaPelayo,
    },
    {
      buttonUrl: "https://ipecus.com.ar/",
      buttonText: "Visitar sitio",
      imageTop: logoIpecus,
      title: "IPECUS",
      subtitulo: "Sitio web empresarial",
      backgroundImage: ipecus,
    },
    {
      buttonUrl: "https://owl-track.com/",
      buttonText: "Visitar sitio",
      imageTop: logoOwltrack,
      title: "OWLTRACK",
      subtitulo: "Sitio web empresarial",
      backgroundImage: owltrack,
    },
    {
      buttonUrl: "https://www.argefix.ar/",
      buttonText: "Visitar sitio",
      imageTop: logoArgefix,
      title: "ARGEFIX",
      subtitulo: "Sitio web empresarial",
      backgroundImage: argefix,
    },
    {
      buttonUrl: "https://viveropehuajo.com.ar/",
      buttonText: "Visitar sitio",
      imageTop: logoVivero,
      title: "VIVERO PEHUAJÓ",
      subtitulo: "Sitio web personal",
      backgroundImage: Vivero,
    },
    {
      buttonUrl: "https://diegofernandezlocutor.com/",
      buttonText: "Visitar sitio",
      imageTop: logoDiegoFernandez,
      title: "DIEGO FERNANDEZ",
      subtitulo: "Sitio web personal",
      backgroundImage: diegoFernandez,
    },
      {
      buttonUrl: "https://www.cenea.com.ar/",
      buttonText: "Visitar sitio",
      imageTop: logoCenea,
      title: "CENEA",
      subtitulo: "Sitio web personal",
      backgroundImage: cenea,
    },
    {
      buttonUrl: "https://espacioanaliamardaras.com.ar/",
      buttonText: "Visitar sitio",
      imageTop: logoAnaliaMardaras,
      title: "ESPACIO ANALÍA MARDARÁS",
      subtitulo: "Sitio web personal",
      backgroundImage: analiaMardaras,
    },
     {
      buttonUrl: "https://instituto148pehuajo.com.ar/",
      buttonText: "Visitar sitio",
      imageTop: logoInstituto,
      title: "I.S.F.D. y T. Nº 148",
      subtitulo: "Sitio web personal",
      backgroundImage: instituto,
    },
      {
      buttonUrl: "https://monicadraghi.com/",
      buttonText: "Visitar sitio",
      imageTop: logoMonicaDragh,
      title: "MÓNICA DRAGHI",
      subtitulo: "Sitio web personal",
      backgroundImage: monicaDraghi,
    },
      {
      buttonUrl: "https://neurolog.com.ar/",
      buttonText: "Visitar sitio",
      imageTop: logoNeurolog,
      title: "NEUROLOG",
      subtitulo: "Sitio web personal",
      backgroundImage: neurolog,
    },
       {
      buttonUrl: "https://www.obroinpehuajo.com.ar/",
      buttonText: "Visitar sitio",
      imageTop: logoObroin,
      title: "OBROIN",
      subtitulo: "Sitio web personal",
      backgroundImage: obroin,
    },
        {
      buttonUrl: "https://virtualval.com.ar/",
      buttonText: "Visitar sitio",
      imageTop: logoVirtualVal,
      title: "VIRTUAL VAL",
      subtitulo: "Sitio web personal",
      backgroundImage: virtualVal,
    },
     {
      buttonUrl: "https://mundopiloto.com.ar/",
      buttonText: "Visitar sitio",
      imageTop: logoMundoPiloto,
      title: "MUNDO PILOTO",
      subtitulo: "Sitio web personal",
      backgroundImage: mundoPiloto,
    },
      {
      buttonUrl: "https://caroroaccesorios.com.ar/",
      buttonText: "Visitar sitio",
      imageTop: logoCaroroAccesorios,
      title: "CARORO ACCESORIOS",
      subtitulo: "Sitio web personal",
      backgroundImage: caroroAccesorios,
    },
  ];
  const settings = {
    dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3, 
  slidesToScroll: 1,
      centerMode: true,
    centerPadding: "0px",
  autoplay: true,
  autoplaySpeed: 3000,
  responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          centerMode: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "20px",
        },
      },
    ],
  };

  return (
    <div className="contenedor-tarjetas">
      <Slider {...settings}>
        {cardsData.map((data, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "1em",
            }}
          >
            <a
              href={data.buttonUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="card-link"
            >
              <Card
                hoverable
                cover={
                  <div
                    style={{
                      backgroundImage: `url(${data.backgroundImage})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      height: "200px",
                      borderRadius: "8px 8px 0 0",
                    }}
                  />
                }
                className="contenedor-card-trabajo"
              >
                <div className="card-meta">
                  <img
                    src={data.imageTop}
                    alt={data.title}
                    className="card-image"
                  />
                  <h3 className="card-title">{data.title}</h3>
                </div>
              </Card>
            </a>
          </div>
        ))}
      </Slider>
    </div>
  );
};
